






import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

@Component({})
export default class Typography extends Vue {
  @Prop({ default: 'div' }) readonly component?: string;
  @Prop(String) readonly background?: string;
  @Prop(String) readonly backgroundColor?: string;
  @Prop(String) readonly border?: string;
  @Prop(String) readonly borderRadius?: string;
  @Prop(String) readonly boxShadow?: string;
  @Prop(String) readonly margin?: string;
  @Prop(String) readonly padding?: string;
  @Prop(String) readonly width?: string;
  @Prop(String) readonly height?: string;
  @Prop(String) readonly minWidth?: string;
  @Prop(String) readonly textAlign?: string;

  get style() {
    return `
      ${this.background ? `background: ${this.background};` : ''}
      ${
        this.backgroundColor ? `background-color: ${this.backgroundColor};` : ''
      }
      ${this.border ? `border: ${this.border};` : ''}
      ${this.borderRadius ? `border-radius: ${this.borderRadius};` : ''}
      ${this.boxShadow ? `box-shadow: ${this.boxShadow};` : ''}
      ${this.margin ? `margin: ${this.margin};` : ''}
      ${this.padding ? `padding: ${this.padding};` : ''}
      ${this.width ? `width: ${this.width};` : ''}
      ${this.height ? `height: ${this.height};` : ''}
      ${this.minWidth ? `min-width: ${this.minWidth};` : ''}
      ${this.textAlign ? `text-align: ${this.textAlign};` : ''}
    `;
  }

  @Emit('click')
  click() {}
}
